import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card__head d-flex aling-items-center" }
const _hoisted_2 = { class: "d-flex aling-items-center ml-2" }
const _hoisted_3 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "mt-1 mb-0" }
const _hoisted_6 = { class: "my-0 text-gray" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "btn-stripped" }
const _hoisted_11 = { class: "btn-stripped text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card--slim" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InlineSvgScoped, {
              src: 
                                require(`@/assets/images/entrancePlants/icon-apartment.svg`)
                            ,
              "aria-label": "icon-apartment"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.apartment.name), 1),
            _createVNode("small", _hoisted_6, [
              (_ctx.gates.length>1)
                ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(`${_ctx.$t("AppResourceEP.Gates")}: `), 1))
                : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(`${_ctx.$t("AppResourceEP.Gate")}: `), 1)),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gates, (gate, index) => {
                return (_openBlock(), _createBlock("span", { key: index }, [
                  _createTextVNode(_toDisplayString(gate), 1),
                  (index < _ctx.gates.length - 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, ", "))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_ElDropdown, {
          class: "ml-auto my-auto p-button-text mr-1",
          trigger: "click",
          placement: "bottom-end",
          "popper-class": "el-dropdown__popper el-dropdown--context"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ElDropdownItem, {
                  disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                  onClick: _ctx.editApartment
                }, {
                  default: _withCtx(() => [
                    _createVNode("button", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_ElDropdownItem, {
                  disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                  onClick: _ctx.deleteApartment
                }, {
                  default: _withCtx(() => [
                    _createVNode("button", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('AppResource.More'),
              class: "ml-auto p-button-text"
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}